import React, { Component } from 'react'
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  TelegramShareButton,
  RedditShareButton,
  WhatsappShareButton,
  FacebookIcon,
  TwitterIcon,
  TelegramIcon,
  LinkedinIcon,
  RedditIcon,
  WhatsappIcon,
} from 'react-share'

class SocialShare extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    const iconSize = 36
    const { postPath, postData, hashTags } = this.props
    const post = postData.frontmatter
    const url = postPath
    return (
      <div className="social-share">
        <RedditShareButton
          url={url}
          title={post.title}
          caption={post.excerpt}
          tags={hashTags}
        >
          <RedditIcon round size={iconSize} />
        </RedditShareButton>
        <TwitterShareButton
          url={url}
          via="phanor"
          title={post.title}
          hashtags={hashTags}
        >
          <TwitterIcon round size={iconSize} />
        </TwitterShareButton>
        <FacebookShareButton url={url} quote={post.excerpt}>
          <FacebookIcon round size={iconSize} />
        </FacebookShareButton>
        <LinkedinShareButton
          url={url}
          title={post.title}
          description={post.excerpt}
        >
          <LinkedinIcon round size={iconSize} />
        </LinkedinShareButton>
        <TelegramShareButton url={url}>
          <TelegramIcon round size={iconSize} />
        </TelegramShareButton>
        <WhatsappShareButton url={url} title={post.title}>
          <WhatsappIcon round size={iconSize} />
        </WhatsappShareButton>
      </div>
    )
  }
}

export default SocialShare



// WEBPACK FOOTER //
// ./src/components/SocialShare/SocialShare.jsx